<template>
  <div class="mb-3 mt-3">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('queen_create.title') }}</h1>
      <queen-form :colony="colony" :apiary="apiary"></queen-form>
    </b-container>
  </div>
</template>

<script>
import QueenForm from '../components/QueenForm'
export default {
  name: 'QueenCreate',
  props: ['apiary', 'colony'],
  components: { QueenForm }
}
</script>

<style scoped>

</style>
